import axios from "axios";
import { getSessionStorage } from "../../common/utils/session";
import { sessionKeys } from "../../common/utils/session/sessionKeys";

export const cryptoPortfolioService = axios.create({
    baseURL: process.env.REACT_APP_CRYPTOPORTFOLIO_BASE_URL
});

cryptoPortfolioService.interceptors.request.use(function (req) {
    const token = getSessionStorage(sessionKeys.token);

    if (token) {
        req.headers.Authorization = `Bearer ${token}`
    }

    return req;
});